/**
 * Skeleton Idea Card
 * Animated placeholder shown during ideas generation
 */

export default function SkeletonIdeaCard() {
  return (
    <div className="bg-white dark:bg-gray-800 border-2 border-black dark:border-gray-600 rounded-lg p-6 animate-pulse">
      {/* Engagement Badge */}
      <div className="flex items-center justify-between mb-4">
        <div className="h-6 w-20 bg-gray-200 dark:bg-gray-700 rounded"></div>
        <div className="h-4 w-16 bg-gray-200 dark:bg-gray-700 rounded"></div>
      </div>

      {/* Title */}
      <div className="h-6 bg-gray-200 dark:bg-gray-700 rounded mb-3 w-3/4"></div>

      {/* Description */}
      <div className="space-y-2 mb-4">
        <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-full"></div>
        <div className="h-4 bg-gray-200 dark:bg-gray-700 rounded w-5/6"></div>
      </div>

      {/* Platforms */}
      <div className="flex flex-wrap gap-2 mb-4">
        <div className="h-8 w-24 bg-gray-200 dark:bg-gray-700 rounded"></div>
        <div className="h-8 w-28 bg-gray-200 dark:bg-gray-700 rounded"></div>
        <div className="h-8 w-20 bg-gray-200 dark:bg-gray-700 rounded"></div>
      </div>

      {/* Action Buttons */}
      <div className="flex gap-3">
        <div className="flex-1 h-10 bg-gray-200 dark:bg-gray-700 rounded"></div>
        <div className="flex-1 h-10 bg-gray-200 dark:bg-gray-700 rounded"></div>
      </div>
    </div>
  );
}
